<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/arac/listesi">{{ $t('menu.vehicles') }}</router-link> / {{ item.name_readable }}
        </div>
        <div class="va-card__header-actions"/>
      </template>
    </va-card>
    <div class="row">
      <div class="flex md6 xs12">
        <va-card 
          class="vehicle-detail__info"
          overlay
          titleOnImage
          :image="!!item.images_readable && item.images_readable.length > 0 ? item.images_readable[0] : ''"
          :title="item.name_readable"
        >
          <template slot="actions">
            <va-badge color="secondary">{{!!item.segment ? item.segment.name_readable : ''}}</va-badge>
            <va-badge :color="item.is_active ? 'success' : 'gray'" outline style="border-color:transparent;">
              <i :class="item.is_active ? 'fa fa-toggle-on fa-lg' : 'fa fa-toggle-off fa-lg'" />
            </va-badge>
          </template>
          <div v-if="!!item.images_readable && item.images_readable.length > 1" class="pt-3">
            <carousel :perPage="1" :autoplay="true" :autoplayHoverPause="true">
              <slide v-for="(img, index) in sliderImages" :key="index" class="text--center">
                <img :src="img"/>
              </slide>
            </carousel>
          </div>
        </va-card>
      </div>
      <div class="flex md6 xs12">
        <va-card
          class="vehicle-detail__properties"
          stripe="secondary"
          title="Özellikler"
        >
          <va-list fit class="py-0" style="border: none; box-shadow: none;">
            <va-item>
              <va-item-section side>
                <va-item-label>Ücretsiz km Hakkı</va-item-label>
              </va-item-section>
              <va-item-section class="text--right">
                <va-item-label>{{item.daily_free_km}}<va-icon color="gray" class="appended">km/gün</va-icon></va-item-label>
              </va-item-section>
            </va-item>
            <template v-for="(val, key) in item.properties">
              <va-item :key="key">
                <va-item-section side>
                  <va-item-label>
                    {{ getPropertyLabel(key) }}
                  </va-item-label>
                </va-item-section>
                <va-item-section class="text--right">
                  <va-item-label>
                    {{ getPropertyReadable(key,val) }}
                  </va-item-label>
                </va-item-section>
              </va-item>
            </template>
          </va-list>
        </va-card>
        <va-card
          class="vehicle-detail__pricing mt-3"
          stripe="secondary"
          title="Günlük Kiralama Fiyatları"
        >
          <va-list fit class="py-0" style="border: none; box-shadow: none;">
            <template v-for="(val, key, i) in item.prices">
              <va-item :key="key">
                <va-item-section side>
                  <va-icon color="gray" name="" class="prepended">{{key}}</va-icon>
                </va-item-section>
                <va-item-section class="text--center">
                  <va-item-label>
                    {{ getPriceReadable(key) }}
                  </va-item-label>
                </va-item-section>
                <va-item-section side>
                  {{val}}
                  <va-icon color="gray" name="" size="md" class="appended">₺/gün</va-icon>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="i < item.prices.length - 1" :key="'separator' + key" />
            </template>
          </va-list>
        </va-card>
      </div>
      <div class="flex xs12 text--right">
        <va-button color="info" icon="fa fa-edit" :to="'/arac/'+item.id+'/duzenleme'">{{ $t('tables.actions.edit') }}</va-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import vehicleServices from '../../services/api/vehicle'
export default {
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      item: {
        images_readable: null
      }
    }
  },
  computed: {
    sliderImages: function() {
      let images = JSON.parse(JSON.stringify(this.item.images_readable));
      images.shift();
      return images;
    }
  },
  methods: {
    async getVehicle(id) {
      const result = await vehicleServices.get(id, {
        params: {
          'include': 'segment'
        }
      });
      if(result.error){
        return ;
      }
      this.item = result.data.data;
    },
    getPriceReadable(val) {
      if(val == '1+') {
        return '1-4 Gün Fiyatı';
      }
      else if(val == '5+') {
        return '5-7 Gün Fiyatı';
      }
      else if(val == '8+') {
        return '8-15 Gün Fiyatı';
      }
      else if(val == '16+') {
        return '16+ Gün Fiyatı';
      }
    },
    getPropertyLabel(key) {
      if(key == 'transmission') {
        return 'Vites Türü';
      }
      else if(key == 'fuel_type') {
        return 'Yakıt Türü';
      }
      else if(key == 'seat_count') {
        return 'Koltuk Sayısı';
      }
      else if(key == 'door_count') {
        return 'Kapı Sayısı';
      }
      else if(key == 'luggage_size') {
        return 'Bagaj Büyüklüğü';
      }
    },
    getPropertyReadable(key,val) {
      if(val == 'automatic') {
        return 'Otomatik Vites';
      }
      else if(val == 'manuel') {
        return 'Manuel Vites';
      }
      else if(val == 'diesel') {
        return 'Diesel';
      }
      else if(val == 'gas') {
        return 'Benzin';
      }
      else if(key == 'door_count' || key == 'seat_count') {
        return val + ' adet';
      }
      else if(key == 'luggage_size') {
        return val + ' Valiz'
      }
    }
  },
  created () {
    if(this.$route.params.id) {
      this.getVehicle(this.$route.params.id);
    }
  }
}
</script>

<style lang="scss">
.vehicle-detail__info {
  .va-card__image {
    .va-card__image-overlay {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  .va-card__header {
    .va-card__header-inner {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  &:hover {
    .va-card__image {
      img {
        object-fit: contain;
      }
      .va-card__image-overlay {
        background-color: transparent;
      }
    }
  }
  .va-icon.appended {
    font-size: 1rem;
  }
  .VueCarousel-inner {
    text-align: center;
    img {max-width: 100%; max-height: 300px; width: 100%; height: auto;}
  }
  .VueCarousel-dot-container, .VueCarousel-dot {
    margin: 0!important;
  }
}
.vehicle-detail__pricing {
  .va-item-section.va-item-section--side .va-icon.prepended {
    line-height: 1;
  }
  .va-item-section.va-item-section--side .va-icon.appended {
    font-size: 1rem;
  }
}
</style>